import type { FaireProductEntity } from "../../entity_types/product";

export const p_vvm6fdfk5x: FaireProductEntity = {
  token: "p_vvm6fdfk5x",
  type: "product",
  name: "Nico Dark Dog Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/576e543e3525708a9c57f70c40f0dfe2852bd1a32257da3c2779fb040731fa0b.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.5,
  description: "Dog Towel\n\nOur signature towel. Gone to the dogs.\n\n\nThe Geometry products you love, now perfectly designed for your pup! Our Dog Towels are lightweight, highly absorbent and quick drying, so you can spend less time washing and more time cuddling your furry friends. \n\n\n...\n\n\n\n * ♺ Made from post-consumer recycled materials \n * 30\" x 30\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\n\n\nPet Responsibly. \n\nWith its natural softness and ultra-absorbent weave, our Dog Towels are guaranteed to be your new favorite companion (besides your doggy, of course!) The best part? They’re also friends to the environment. Our towels are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And due to its innovative weave, high absorbency and quick dry time, you’ll wash it less often, helping to minimize yours. \n\n\n",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:54.703Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
